import * as React from "react"

export const ToothErrorIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="142" height="140" viewBox="0 0 142 140" fill="none">
      <ellipse cx="71.5655" cy="118.013" rx="51.2845" ry="10.3334" fill="#E4F1F9" />
      <path
        d="M54.8254 14.8846C51.3611 13.4154 48.0235 12 40.7644 12C25.6733 12 22.5776 31.5137 22.5776 44.5229C22.5776 52.9401 26.2063 61.8435 28.7679 68.129C30.1654 71.558 31.2454 74.2078 31.2454 75.5745C31.2454 79.4462 34.4184 118.396 52.4504 118.396C58.5797 118.396 61.6083 114.628 62.3564 112.743C62.879 111.427 65.6068 94.159 66.1485 91.681C66.6902 89.2031 68.7798 87.8093 71.5658 87.8093C74.3519 87.8093 76.4414 89.2031 76.9832 91.681C77.5249 94.159 80.1604 111.195 80.7753 112.743C81.5234 114.628 84.552 118.396 90.6813 118.396C108.713 118.396 111.886 79.4462 111.886 75.5745C111.886 74.2078 112.966 71.558 114.364 68.129C116.925 61.8435 120.554 52.9401 120.554 44.5229C120.554 31.5137 117.458 12 102.367 12C95.1082 12 91.7706 13.4154 88.3063 14.8846C84.5685 16.4697 80.6832 18.1174 71.5658 18.1174C62.4485 18.1174 58.5632 16.4697 54.8254 14.8846Z"
        fill="white"
        stroke="#161819"
        strokeWidth="2"
      />
      <path d="M60 59.2149C68.5 56 81.3653 57.4252 84 66" stroke="#2462A2" strokeWidth="2" />
      <circle cx="98.3556" cy="57.1611" r="4.59264" fill="#E4F1F9" />
      <circle cx="44.7753" cy="57.1611" r="4.59264" fill="#E4F1F9" />
      <circle cx="92.6148" cy="49.8893" r="2.67904" fill="#2462A2" />
      <circle cx="50.516" cy="49.8893" r="2.67904" fill="#2462A2" />
      <path d="M24.4909 57.9267C8.41664 62.1366 2.67583 84.3344 30.2317 84.3344" stroke="#161819" />
      <path d="M30.2319 84.7167C31.1887 83.2072 33.906 80.5763 37.1209 82.1289" stroke="#161819" />
      <path d="M30.2319 84.334C31.7628 85.4822 35.7219 85.4056 36.7382 85.0995" stroke="#161819" />
      <path d="M117.63 57.9267C133.704 62.1366 139.445 84.3344 111.889 84.3344" stroke="#161819" />
      <path d="M111.889 84.7167C110.932 83.2072 108.215 80.5763 105 82.1289" stroke="#161819" />
      <path d="M111.889 84.334C110.358 85.4822 106.399 85.4056 105.383 85.0995" stroke="#161819" />
    </svg>
  )
}
